var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.586,15.121v-5.207l4.414-4.414L18.586.086l-3.914,3.914h-5.636C8.783,1.756,6.896,0,4.586,0,2.104,0,.086,2.019.086,4.5c0,1.953,1.258,3.602,3,4.224v7.276H.086v8h8v-8h-3v-7.051c1.731-.195,3.157-1.36,3.724-2.949h4.862l3.914,3.914v5.207c-2,.457-3.5,2.242-3.5,4.379,0,2.481,2.019,4.5,4.5,4.5s4.5-2.019,4.5-4.5c0-2.137-1.5-3.922-3.5-4.379Z",
    fill: "#7E7E8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowAlt);
export default __webpack_public_path__ + "static/media/workflow-alt.ff6dfbf5796bd197ecc1ec8e01795dcb.svg";
export { ForwardRef as ReactComponent };